<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Información del producto</h1>
    <div class="information" v-if="product">
      <p class="information__text"><strong class="information__text--strong">Título (ES): </strong>{{product.title_es}}</p>
      <p class="information__text"><strong class="information__text--strong">Título (EN): </strong>{{product.title_en}}</p>
      <p v-if="product.designer_id" class="information__text"><strong class="information__text--strong">Diseñador: </strong>{{product.designer}}</p>
      <p v-if="product.price" class="information__text"><strong class="information__text--strong">Precio: </strong>{{product.price|price}}</p>
      <p v-if="product.discount_type" class="information__text"><strong class="information__text--strong">Tipo de descuento: </strong>{{product.discount_type}}</p>
      <p v-if="product.discount_type" class="information__text"><strong class="information__text--strong">Descuento:</strong>{{product.discount}}</p>
      <p v-if="status" class="information__text"><strong class="information__text--strong">Estatus: </strong>{{status}}</p>
    </div>
  </div>
</template>

<script>
import {product_status} from './mocks'
import {config} from '@/core/config/base'
export default {
  props: {
    product: {
      type: Object
    }
  },
  computed: {
    status: function () {
      let status = product_status.filter(element => element.id === this.product.status_id)
      return status[0].name
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/products/view.vue